import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'
import deviceApi from '@/api/device'

interface web2appPayload {
    group: string
    function: string
    args: any
}

@Component({
    computed: mapGetters({
        current: accountTypes.CURRENT,
    })
})
export default class LoginView extends Vue {

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    updates: any[] = []

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    current!: account.TCurrent

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        //모바일앱 푸시를 위한 기기 사용자 등록 처리
        var web2appPayload: web2appPayload = {
            group: 'login',
            function: 'logined',
            args: {
                userId: this.current.user.id,
                topics: this.current.topics // 토픽 정보
            }
        };
        (window as any).dsmobileapp.web2app(web2appPayload.group, web2appPayload.function, web2appPayload.args);

        // 버전 정보 확인해서 업데이트 페이지로 redirect 하는 로직 추가
        // deviceApi.getLatestUpdate().then((results) => {
        //     this.updates = results
        // })

        const { returnUrl, ...etc } = this.$route.query
        console.log('returnUrl : ' + returnUrl)
        //https://localhost:8080/login?returnUrl=/home/main

        if (returnUrl && typeof returnUrl === 'string') {
            var decodeReturnUrl = decodeURIComponent(returnUrl)
            this.$router.push({
                path: decodeReturnUrl.replace('/mobile', ''),
                query: etc,
            })
        } else {
                this.$router.push({
                path: '/',
                query: etc,
            })
        }
    }
} 